<template>
  <div id="app">
    <template v-if="show">
      <el-container>
        <el-header height="56px">
          <header-page></header-page>
        </el-header>
        <el-container>
          <el-aside class="el-aside">
            <left-menu :list="menuList" :active="active"></left-menu>
          </el-aside>
          <el-container>
            <el-main>
                <header-breadcrumb :list="breadcrumbList"></header-breadcrumb>
                <router-view />
            </el-main>
          </el-container>
        </el-container>
      </el-container>
    </template>
    <template v-else>
        <router-view />
    </template>
  </div>
</template>

<script>
import headerPage from '@/components/header'
import leftMenu from '@/components/left-menu'
import headerBreadcrumb from "@/components/header-breadcrumb"
import {routes} from '@/router/router.config'
import {getCache} from '@/utils'

export default {
  name: 'App',
  components:{
    'header-page':headerPage,
    'left-menu':leftMenu,
    'header-breadcrumb':headerBreadcrumb
  },
  data(){
    return {
      menuList:[],
      breadcrumbList:[],
      active:'',
      show:false,
    }
  },
  watch:{
    '$route':{
      handler(to){
        this.show = to.path !== '/login'
        if(to.path !== 'login'){
          this.breadcrumbList = to.matched
          this.active = to.name
        }
      },
      deep:true
    }
  },
  created(){
     this.getMenuList()
  },
  methods:{
    getMenuList(){
      this.menuList = routes.filter((item)=>{
        if('level' in item.meta){
            item.meta.show = getCache('xczn_merchant_level') == 2
        }
        return item.meta.show
      })
    }
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
#app{
 height: 100vh;
}
.el-header{
  padding:0 !important;
}
.el-aside {
  width: 200px!important;
  overflow-x: hidden;
}
.el-container{
  background-color: #E4E7EA;
}
.el-card__body, .el-main{
  padding:0 !important;
}

.custom-marker-car{
  position: relative;
  width: 59px;
  height: 84px;
  background: url('./assets/dr5.png') no-repeat;
  background-position: center center;
  background-size: 60px;
} 
.custom-marker-car > span {
  position:absolute;
  top:50%;
  left:50%;
  width: 80px;
  text-align: center;
  transform: translate(-50%,-50%);
  font-size: 12px;
}

.custom-poi-name {
  text-align: center;
  padding: 2px;
  width: 80px;
  background-color: #fff;
}

/* .select-marker-poi{
  width: 30px;
  height: 30px;
  background: url('./assets/poi-marker-red.png') no-repeat;
  background-position: center center;
  background-size: 20px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue